import React, { useEffect, useState } from 'react';
// import styles from './DistributorsTable.module.scss';
import _ from "lodash";
import { Link } from "react-router-dom";
import { $t } from "../../helpers/translator";
import api from "../../helpers/api";
import DataTable from "../miscellaneous/DataTable/DataTable";
import Input from "../miscellaneous/Input/Input";
import Modal from "../miscellaneous/Modal/Modal";
import DistributorCreateEdit from "components/DistributorCreateEdit/DistributorCreateEdit";
import MultiSelect from "../miscellaneous/MultiSelect/MultiSelect";
import { getCountries } from "../../store/data-slice";
import { useDispatch } from "react-redux";
import HasPermission from 'helpers/permissions/HasPermission';

const DistributorsTable = (props) => {
    const [ isTableLoading, setIsTableLoading ] = useState(false);
    const [ payload, setPayload ] = useState({
        sort: 'id',
        order: 'asc',
        search: '',
        country: '',
        min_clinics: '',
        max_clinics: '',
        page: 1,
        per_page: 15,
    });
    const [ pagination, setPagination ] = useState(null);
    const [ distributors, setDistributors ] = useState([]);
    const [ countryOptions, setCountryOptions ] = useState([]);
    const [ addModalShow, setAddModalShow ] = useState(false);
    const [ editModalShow, setEditModalShow ] = useState(false);
    const [ distributorToEdit, setDistributorToEdit ] = useState(null);

    const dispatch = useDispatch()

    useEffect(() => {
        //getDistributors();
        loadCountries();
    }, [])

    useEffect(() => {
        getDistributors();
    }, [ payload ])

    const loadCountries = async () => {
        try {
            let res = await dispatch(getCountries());
            if (res) {
                setCountryOptions([ {
                    label: 'All',
                    value: '',
                }, ...res ]);
            }
        } catch (e) {
            console.error('err getting countries,', e);
        }
    }

    const getAPIUrl = () => {
        let p = { ...payload };
        return `/distributor?sort=${p.sort}&order=${p.order}&search=${p.search}&country=${p.country}&min_clinics=${p.min_clinics}&max_clinics=${p.max_clinics}&page=${p.page}&per_page=${p.per_page}`;
    }

    const getDistributors = async () => {
        setIsTableLoading(true);
        try {
            let p = { ...payload };
            let res = await api.get(getAPIUrl());
            let pagination = null;
            let distributors = [];

            if (res && res.data && res.data.success) {
                distributors = res.data.data.data;
                pagination = res.data.data.pagination;

                _.forEach(distributors, (v, k) => {
                    v.id = <Link to={ `/distributor/${v.id}` }>{ v.id }</Link>

                })

                setDistributors(distributors);
                setPagination(pagination);
            }
        } catch (e) {
            console.error('err get platforms:', e);
        } finally {
            setIsTableLoading(false);
        }
    }

    const dataTableActionHandler = (data) => {
        if (data.key === 'page') {
            setPayload({ ...payload, page: data.value });
        } else if (data.key === 'header') {
            const newPayload = { ...payload };
            if (payload.sort === data.value) {
                newPayload.order = payload.order === 'desc' ? 'asc' : 'desc'
            }
            newPayload.sort = data.value;
            setPayload(newPayload);
        }
    }

    const searchHandler = (e) => {
        setPayload({ ...payload, page: 1, search: e.target.value });
    }


    const countryChangeHandler = (data) => {
        setPayload({ ...payload, page: 1, country: data.value });
    }

    const getCountryNameById = (id) => {
        let res = _.findIndex(countryOptions, function (o) {
            return o.id === id;
        });

        if (res < 0) {
            return 'All Countries';
        }

        return $t('countries.' + countryOptions[ res ].name);
    }

    const renderCreateEditModal = () => {
        if (addModalShow || editModalShow) {
            return (
                <Modal content={
                    <DistributorCreateEdit mode={ editModalShow ? 'edit' : 'create' }
                        userType={ 5 }
                        distributorData={ distributorToEdit }
                        onSuccess={ onModalSuccess.bind(this) } />
                }
                    onClose={ (e) => {
                        closeModals()
                    } }
                    visible={ addModalShow || editModalShow }
                />
            );
        }
        return null;
    }

    const closeModals = () => {
        setAddModalShow(false);
        setEditModalShow(false);
    }

    const onModalSuccess = () => {
        closeModals();
        getDistributors();
    }

    const editDistributor = (distributor) => {
        setDistributorToEdit(distributor);
        setEditModalShow(true);
    }

    const addDistributor = () => {
        setDistributorToEdit(null);
        setAddModalShow(true);
    }

    let tableSorted = {
        id: payload.sort,
        desc: payload.order === 'desc'
    }

    let tableHeaders = [
        {
            name: $t('global.distributors.code'),
            id: 'id',
            clickable: true
        },
        {
            name: $t('global.distributors.name'),
            id: 'name',
            clickable: true
        },
        {
            name: $t('global.distributors.country'),
            id: 'country',
            render: (value) => {
                return Array.isArray(value) ? value.join(', ') : ''
            },
            clickable: true
        },
        {
            name: $t('global.distributors.totalClinics'),
            id: 'total_clinics',
            clickable: true
        },
        {
            name: $t('global.distributors.totalPlatforms'),
            id: 'total_platforms',
            clickable: true
        },
        {
            name: $t('global.distributors.totalApplicators'),
            id: 'total_applicators',
            clickable: true
        }
    ];

    const apiUrl = getAPIUrl();

    return (
        <>
            { renderCreateEditModal() }
            <div className={ 'container' }>
                <div className={ 'box' }>
                    <div className={ 'alma-box' }>
                        <div className={ 'alma-box-header' }>
                            <div><h3>{ props.header }</h3></div>
                            <HasPermission permission="distributor.create">
                                <button className={ `${'alma-button'} ${'alma-button-primary'}` } onClick={ () => {
                                    addDistributor()
                                } }>Add new Distributor</button>
                            </HasPermission>
                        </div>
                        <div className={ 'alma-fields-row align-items-center' }>
                            <div className={ 'alma-field-container' }>
                                <div className={ 'alma-field-header' }>{ $t('global.distributors.searchDistributor') }</div>
                                <Input name="search"
                                    // disabled={isTableLoading}
                                    delay={ 500 }
                                    className={ `${'alma-input'}` }
                                    type="text"
                                    value={ payload.search }
                                    placeholder={ $t('global.distributors.searchByNameCodeOrCountry') }
                                    onChange={ (e) => searchHandler(e) } />
                            </div>
                            <div className={ 'alma-field-container' }>
                                <div className={ 'alma-field-header' }>{ $t('global.distributors.country') }</div>
                                <MultiSelect
                                    searchable
                                    options={ countryOptions }
                                    placeholder={ $t('global.account.country') }
                                    onValueChange={ (data) => countryChangeHandler(data) }
                                    selected={ {
                                        label: getCountryNameById(payload.country),
                                        value: payload.country
                                    } }
                                />

                            </div>
                            <div className={ 'alma-field-container' }>
                                <div className={ 'alma-field-header' }>{ $t('global.distributors.numberOfClinics') }</div>
                                <div className='d-flex'>
                                    <div>
                                        <Input name="search"
                                            // disabled={isTableLoading}
                                            delay={ 500 }
                                            className={ `${'alma-input'}` }
                                            type="text"
                                            value={ payload.search }
                                            placeholder={ $t('global.distributors.min') }
                                            onChange={ (e) => { setPayload({ ...payload, min_clinics: e.target.value }) } } />
                                    </div>
                                    <div style={ { marginLeft: '10px' } }>
                                        <Input name="search"
                                            // disabled={isTableLoading}
                                            delay={ 500 }
                                            className={ `${'alma-input'}` }
                                            type="text"
                                            value={ payload.search }
                                            placeholder={ $t('global.distributors.max') }
                                            onChange={ (e) => { setPayload({ ...payload, max_clinics: e.target.value }) } } />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <DataTable data={ distributors }
                                headers={ tableHeaders }
                                pagination={ pagination }
                                loading={ isTableLoading }
                                sorted={ tableSorted }
                                apiUrl={ getAPIUrl() }
                                onAction={ (e) => dataTableActionHandler(e) }
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default DistributorsTable;

